/**
 * Scores a volunteer's saved answers against a module's questions.
 *
 * `responses[i]` is the index of the answer picked for `questions[i]`. Saved
 * answers can be wrong (for example another module's answers saved into this
 * module's record, #1403), so an index that doesn't point at one of the
 * question's answers counts as unanswered instead of throwing.
 *
 * - `questionsLeft`: questions without a valid answer.
 * - `allCorrect`: every question has a valid answer and all of them are correct.
 */
export function scoreLessonResponses(questions = [], responses = []) {
  const safeQuestions = Array.isArray(questions) ? questions : [];
  const safeResponses = Array.isArray(responses) ? responses : [];

  const answered = safeQuestions
    .map((question, i) => answerAt(question, safeResponses[i]))
    .filter((answer) => answer !== undefined);

  return {
    questionsLeft: safeQuestions.length - answered.length,
    allCorrect:
      safeQuestions.length > 0 &&
      answered.length === safeQuestions.length &&
      answered.every((answer) => answer.correct === true),
  };
}

function answerAt(question, response) {
  const answers =
    question && Array.isArray(question.answers) ? question.answers : [];
  if (
    !Number.isInteger(response) ||
    response < 0 ||
    response >= answers.length
  ) {
    return undefined;
  }
  return answers[response] || undefined;
}
